/**
 * Created by Bart Decorte
 * Date: 2019-07-16
 * Time: 10:01
 */

function parseCondition(condition) {
  let allowedSurroundingChars = '\\s';
  let regExp = new RegExp(`([${allowedSurroundingChars}])or([${allowedSurroundingChars}])`, 'gi');
  condition = condition.replace(regExp, '$1||$2');
  regExp = new RegExp(`([${allowedSurroundingChars}])and([${allowedSurroundingChars}])`, 'gi');
  condition = condition.replace(regExp, '$1&&$2');
  return condition;
}

function replaceCondition(condition, params) {
  let allowedSurroundingChars = '=|&\\s!<>\\)\\(';
  for (let key in params) {
    let value = params[key];
    let regExp = `((^|[${allowedSurroundingChars}]))${key}(([${allowedSurroundingChars}]|$))`;

    let replaceString = `$1${value}$3`;
    if (typeof value === "string") {
      replaceString = `$1"${value}"$3`;
    }

    condition = condition.replace(new RegExp(regExp, 'g'), replaceString);
  }
  return condition;
}

function evaluateCondition(condition, params) {
  const temp = condition;
  condition = parseCondition(condition);
  condition = replaceCondition(condition, params);
  return eval(condition);
}

export {
  evaluateCondition
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/condition_helper.js